import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }

import { computed } from 'vue';
import { BAlert, BButton, BModal, BSpinner } from 'bootstrap-vue-next';
import { formatDateTime } from '@/utils/date-utils';
import { InviteType } from '@/gql/graphql';
import { useUserStore } from '@/store/user';

interface Props {
  invite: InviteType;
  show: boolean;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'InviteDetail',
  props: {
    invite: {},
    show: { type: Boolean }
  },
  emits: ['success', 'close'],
  setup(__props: any, { emit: __emit }) {

const userStore = useUserStore();

// --- Props for the component ---
const props = __props;
const emits = __emit;

// --- Computed Properties ---
const show = computed<boolean>(() => {
  return props.show;
});

function handleCloseModal() {
  emits('close');
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (props.invite.inviter && props.invite.organization)
    ? (_openBlock(), _createBlock(_unref(BModal), {
        key: 0,
        modelValue: show.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((show).value = $event)),
        onHide: handleCloseModal
      }, {
        title: _withCtx(() => [
          _createVNode(_component_font_awesome_icon, {
            icon: ['fas', 'user-plus'],
            class: "me-2"
          }),
          _cache[1] || (_cache[1] = _createElementVNode("strong", null, "Invite Details", -1))
        ]),
        footer: _withCtx(() => [
          _createVNode(_unref(BButton), {
            variant: "secondary",
            onClick: handleCloseModal,
            class: "me-2"
          }, {
            default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
              _createElementVNode("span", null, "Close", -1)
            ]))]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createElementVNode("p", null, [
              _cache[2] || (_cache[2] = _createElementVNode("strong", null, "Status: ", -1)),
              _createTextVNode(_toDisplayString(props.invite.status), 1)
            ]),
            _createElementVNode("p", null, [
              _cache[3] || (_cache[3] = _createElementVNode("strong", null, "Organization: ", -1)),
              _createTextVNode(_toDisplayString(props.invite.organization.name), 1),
              _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
              _cache[5] || (_cache[5] = _createElementVNode("strong", null, "Invite recipient: ", -1)),
              (props.invite.invited)
                ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(props.invite.invited.givenName) + " " + _toDisplayString(props.invite.invited.familyName) + " (" + _toDisplayString(props.invite.invited.email) + ")", 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(props.invite.invitedEmail), 1)),
              _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1)),
              _cache[7] || (_cache[7] = _createElementVNode("strong", null, "User role: ", -1)),
              _createTextVNode(_toDisplayString(props.invite.invitedOrganizationUserRole), 1),
              _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1)),
              _cache[9] || (_cache[9] = _createElementVNode("strong", null, "Invited by: ", -1)),
              _createTextVNode(_toDisplayString(props.invite.inviter.givenName) + " " + _toDisplayString(props.invite.inviter.familyName) + " (" + _toDisplayString(props.invite.inviter.email) + ")", 1),
              _cache[10] || (_cache[10] = _createElementVNode("br", null, null, -1)),
              _cache[11] || (_cache[11] = _createElementVNode("strong", null, "Invited at: ", -1)),
              _createTextVNode(_toDisplayString(_unref(formatDateTime)(props.invite.createdAt)), 1),
              _cache[12] || (_cache[12] = _createElementVNode("br", null, null, -1)),
              _cache[13] || (_cache[13] = _createElementVNode("strong", null, "Last notified: ", -1)),
              _createTextVNode(_toDisplayString(_unref(formatDateTime)(props.invite.lastNotificationAt)), 1),
              _cache[14] || (_cache[14] = _createElementVNode("br", null, null, -1)),
              _cache[15] || (_cache[15] = _createElementVNode("strong", null, "Expires at: ", -1)),
              _createTextVNode(_toDisplayString(_unref(formatDateTime)(props.invite.expiresAt)), 1)
            ]),
            (_unref(userStore).isAdmin || _unref(userStore).id === props.invite.inviter.id)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (props.invite.description)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
                        _cache[16] || (_cache[16] = _createElementVNode("strong", null, "Description: ", -1)),
                        _createTextVNode(_toDisplayString(props.invite.description), 1),
                        _cache[17] || (_cache[17] = _createElementVNode("br", null, null, -1))
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true),
            (props.invite.message)
              ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
                  _cache[18] || (_cache[18] = _createElementVNode("strong", null, "Message: ", -1)),
                  _createTextVNode(_toDisplayString(props.invite.message), 1),
                  _cache[19] || (_cache[19] = _createElementVNode("br", null, null, -1))
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["modelValue"]))
    : _createCommentVNode("", true)
}
}

})